import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Home from "./home";
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Page5 from "./page5";
import Page6 from "./page6";
import End from "./end";
import { getSummaryData } from "@/api/user-new";
import Header from "@/components/Header";
import bwmodel from "@/config/bwmodel";
import { popNativePage, loadImg } from "@/utils";
import html2canvas from "html2canvas";
import { getActiveData } from "@/views/activity_42/api";
import { connect } from "react-redux";
import bridge from "@/config/JSbridge";
import h5Share from "@/utils/h5Share";
import OpenApp from "@/components/OpenApp";
import ModalView from '@/components/modal-view'

const isStorm = bwmodel.app === "storm";

const Active205 = ({ accessToken }) => {
  const currentPage = useRef(0);
  const page0Ref = useRef();
  const page1Ref = useRef();
  const page2Ref = useRef();
  const page3Ref = useRef();
  const page4Ref = useRef();
  const page5Ref = useRef();
  const page6Ref = useRef();
  const page7Ref = useRef();
  const wrapRef = useRef();

  const isLogin = !!accessToken;
  const [showShare, setShowShare] = useState(false);

  const [data, setData] = useState({
    mostZanUser: {},
    mostReadColumnUser: {},
    mostCheckStock: {},
    highestUserStock: {},
    myself: {},
  });
  const [activeData, setActiveData] = useState({});
  const scrollRef = useRef();
  const containerRef = useRef();

  useEffect(() => {
    getActiveData({ activityId: 205 }).then((res) => {
      setActiveData(res);
    });

    getSummaryData().then((res) => {
      const result = {...res}
      result.mostZanUser = res.mostZanUser || {};
      result.mostReadColumnUser = res.mostReadColumnUser || {};
      result.mostCheckStock = res.mostCheckStock || {};
      result.highestUserStock = res.highestUserStock || {};
      result.myself = res.myself || {};
      setData(result);
    });
  }, []);

  useEffect(() => {
    h5Share.main({
      title: `我的2025年度总结已出炉～`,
      desc: "顺便看看2025大盘重要点位和重要时刻",
      link: process.env.REACT_APP_DEMAND_URL + "active_205",
      thumbUrl:
        "https://file.wogoo.com/image/activity/active_205/share-poster.png",
      wxShare: {
        shareData: {
          imgUrl:
            "https://file.wogoo.com/image/activity/active_205/share-poster.png",
        },
      },
      shareData: {
        imgUrl:
          "https://file.wogoo.com/image/activity/active_205/share-poster.png",
      },
    });
  }, []);

  const activityShare = async () => {
    let container;
    switch (currentPage.current) {
      case 0:
        container = page0Ref.current;
        break;
      case 1:
        container = page1Ref.current;
        break;
      case 2:
        container = page2Ref.current;
        break;
      case 3:
        container = page3Ref.current;
        break;
      case 4:
        container = page4Ref.current;
        break;
      case 5:
        container = page5Ref.current;
        break;
      case 6:
        container = page6Ref.current;
        break;
      case 7:
        container = page7Ref.current;
        break;
      default:
        break;
    }

    if (!container) {
      return;
    }
    const element = container.shareContainer();

    const shareFunc = (shareUrl, format = 'jpeg') => {
      bridge.callHandler("nativeEvent", {
        event: "commonTemplateImgShare",
        params: {
          imageData: shareUrl.replace(`data:image/${format};base64,`, ""),
          scaleType: 1,
        },
      });
    };

    const drawElement = (dom) => {
      return new Promise((resolve) => {
        html2canvas(dom, {
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#FFFFFF",
          ignoreElements: (checkDom) => {
            const className = checkDom.className || "";
            const classStr = typeof className === "string" ? className : "";
            if (classStr.includes("next-btn")) {
              return true;
            }
          },
        })
          .then(function (canvas) {
            const url = canvas.toDataURL("image/jpeg", 1);
            resolve(url);
          })
          .catch((err) => {
            console.log(err, "err");
          });
      })
    }

    if (currentPage.current !== 7) {
      const shareBox = document.createElement('div');
      shareBox.style = 'position: fixed;width: 100%;left: 0;top: 0;z-index: -100000';
      const contentBox = document.createElement('div');
      contentBox.style = 'position: relative';

      shareBox.appendChild(contentBox);
      const clonedNode = element.cloneNode(true);
      contentBox.appendChild(clonedNode);
      const qrImg = await loadImg(
        "https://file.wogoo.com/image/activity/active_205/qr-active_205.png"
      );
      qrImg.style = 'width:72px;height:72px;z-index: 10000;position:absolute;right:17px;bottom:23px;'
      contentBox.appendChild(qrImg);
      wrapRef.current.appendChild(shareBox);
      const imgUrl = await drawElement(contentBox);
      shareFunc(imgUrl, 'jpeg');

      wrapRef.current.removeChild(shareBox);
    } else {
      const imgUrl = await drawElement(element);
      shareFunc(imgUrl, 'jpeg');
    }
  };

  const handleNext = (direction = 'down', pageNum) => {
    const clientHeight = containerRef.current.clientHeight;
    
    let top;
    if (direction === 'up') {
      top = -clientHeight * (currentPage.current - 1);
      currentPage.current -= 1;
    } else {
      top = -clientHeight * (currentPage.current + 1);
      currentPage.current += 1;
    }

    scrollRef.current.style.top = top + "px";
    

    if (pageNum === 6) {
      setTimeout(() => {
        setShowShare(true);
      }, 3000)
    }
  };

  const handleShareEnd = () => {
    setShowShare(false);
    activityShare();
  }

  return (
    <Container className={isStorm ? "" : "no-head"} ref={wrapRef}>
      <div className="page-box" ref={containerRef}>
        {isStorm && (
          <Header
            leftClick={popNativePage}
            title="我的2025年度总结"
            right={
              <img
                onClick={activityShare}
                src={
                  bwmodel.theme === "0"
                    ? require(`@/img/share.png`)
                    : require(`@/img/share_dark.png`)
                }
                className="share-img"
                alt=""
              />
            }
          />
        )}
        <div ref={scrollRef} className="scroll-container">
          <Home
            data={data}
            activeData={activeData}
            onNext={handleNext}
            ref={page0Ref}
            isLogin={isLogin}
          />
          <Page1 data={data} onNext={handleNext} ref={page1Ref} />
          <Page2 data={data} onNext={handleNext} ref={page2Ref} />
          <Page3 data={data} onNext={handleNext} ref={page3Ref} />
          <Page4 data={data} onNext={handleNext} ref={page4Ref} />
          <Page5 data={data} onNext={handleNext} ref={page5Ref} />
          <Page6 data={data} onNext={handleNext} ref={page6Ref} />
          <End
            data={data}
            onNext={handleNext}
            ref={page7Ref}
            activeData={activeData}
            onShare={activityShare}
          />
        </div>
      </div>
      {!isStorm && (
        <div>
          <OpenApp bottom="bottom"></OpenApp>
        </div>
      )}
      <ModalView
        visible={showShare}
        onClose={() => setShowShare(false)}
        onOverlayClick={() => setShowShare(false)}
        content={
          <ModalContainer>
            <img className="exit-bg" src="https://file.wogoo.com/image/activity/active_205/exit-bg@2x.png" alt=""/>
            <div className="exit-content">
              <div className="exit-title">亲爱的<span className="share-user">{activeData.user ? activeData.user.nickname : ''}：</span></div>
              <div className="exit-text">回首2025年，你 <span className="stock-win">{data.userStockWinX || 0}%</span>的自选股年度涨幅跑赢了大盘，{Number(data.userStockWinX) >= 50 ? '为您喝彩！' : '再接再厉！'}</div>
              <div className="exit-text">展望2026年，</div>
              <div className="exit-text">愿你所得皆所愿，账户长虹!</div>
              <div className="exit-btn-wrap" onClick={handleShareEnd}>
                <img className="exit-btn" src="https://file.wogoo.com/image/activity/active_205/share-modal-bar@2x.png" alt=""/>
                <img className="exit-finger" src="https://file.wogoo.com/image/activity/active_205/share-end-finger@2x.png" alt=""/>
              </div>
            </div>
          </ModalContainer>
        }
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  accessToken: state.user.accessToken,
});

const ModalContainer = styled.div`
  position: relative;
  .exit-bg {
    width: 310px;
  }
  .exit-content {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    left: 0;
    top: 0;
    padding: 200px 26px 0;
    color: #FFFFFF;
    font-weight: normal;
    font-size: 15px;
    line-height: 27.5px;
  }
  .exit-btn-wrap {
    display: flex;
    justify-content: center;
    margin-top: 14px;
    position: relative;
    .exit-btn {
      width: 270px;
    }
  }
  .stock-win {
    font-size: 22px;
    line-height: 27.5px;
    font-weight: bold;
    color: #FFFB00;
  }
  .share-user {
    color: #FFFB00;
  }
  .exit-finger {
    width: 54px;
    position: absolute;
    height: 53px;
    top: 31px;
    right: 8px;
  }
`;

const Container = styled.div`
  positon: relative;
  word-break: break-all;
  padding-top: 44px;
  &.no-head {
    padding-top: 0px;
    .page {
      height: 100vh;
    }
    .page-box {
      top: 0;
      height: 100vh;
    }
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }
  .page {
    height: calc(100vh - 44px);
    box-sizing: border-box;
    position: relative;
  }
  .home-page {
    background-image: linear-gradient(
      180deg,
      rgba(252, 94, 86, 0.58) 0px,
      rgba(252, 94, 86, 0) 171.5px
    );
    background-color: #fff5eb;
  }
  .award-tip {
    width: 161px;
    margin-top: 5.5px;
  }
  .page1 {
    background-image: linear-gradient(
      180deg,
      rgba(252, 94, 86, 0.58) 0%,
      rgba(252, 94, 86, 0) 171.5px
    );
  }
  .page2 {
    background-color: #fff5eb;
  }
  .data-wrap {
    padding: 33px 8px 0 17px;
    position: relative;
    z-index: 10;
  }
  .data-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 0;
    .logo-img {
      width: 100%;
    }
  }
  .user-data {
    font-weight: 600;
    font-size: 16.5px;
    color: #1f1d1d;
    line-height: 23px;
    margin-bottom: 7px;
  }
  .light-data {
    font-size: 25px;
    line-height: 36px;
    color: #ff0000;
    font-weight: bold;
  }
  .page-box {
    position: absolute;
    left: 0;
    top: 44px;
    width: 100%;
    height: calc(100vh - 44px);
    overflow: hidden;
    background-color: white;
  }
  .page-logo {
    width: 74px;
    position: absolute;
    top: 33px;
    right: 26px;
    .logo-img {
      width: 100%;
    }
  }
  .scroll-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transition: top 0.5s;
  }

  .logo-bg {
    position: absolute;
    top: 23px;
    left: 12px;
    .logo-img {
      width: 92.5px;
    }
  }
  .bg-img {
    width: 100%;
  }
`;

export default connect(mapStateToProps)(Active205);



// WEBPACK FOOTER //
// ./src/views/activity_205/index.js